import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Menu2.css";
import logo from "../../../Assets/logo/soonlogowhite.png";
import { baseURL } from "../../../Api/api";
import { useMenuData } from "./useMenuData";

export default function Menu2() {
  const {
    isLoading,
    error,
    grouped,
    brandIds,
    selectedBrand,
    setSelectedBrand,
    selectedCategory,
    setSelectedCategory,
    searchTerm,
    setSearchTerm,
    categories,
    filteredItems,
  } = useMenuData();

  if (isLoading) return <div className="loading">Loading menu...</div>;
  if (error) return <div className="error">Failed to load menu ❌</div>;
  if (!brandIds.length)
    return <div className="empty">No menu items found.</div>;

  return (
    <div className="menu2-page">
      {/* Header */}
      <header className="menu2-header">
        <div className="header-content">
          <div className="logo-container">
            <img src={logo} alt="logo" className="menu-logo" />
            <div>
              <h1 className="brand-title">Soon Kitchen</h1>
              <h6 className="brand-subtitle">Hybrid Cloud Kitchen</h6>
            </div>
          </div>

          {/* 🔍 Search Bar */}
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search for a dish..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className="search-btn">🔍</button>
          </div>
        </div>
      </header>

      {/* Brand Swiper */}
      <section className="brands-section">
        <Swiper slidesPerView={3.2} spaceBetween={12}>
          {brandIds.map((id) => {
            const brand = grouped[id];
            if (!brand) return null;
            return (
              <SwiperSlide key={id}>
                <button
                  className={`brand-btn ${
                    selectedBrand === id ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedBrand(id);
                    setSelectedCategory("all");
                    setSearchTerm("");
                  }}
                >
                  <div className="brand-content">
                    {console.log("brand", brand)}
                    {brand.brandImage ? (
                      <img
                        src={`${brand.brandImage}`}
                        alt={brand.brandName}
                        className="brand-img"
                      />
                    ) : (
                      <div className="cat-placeholder">🍽️</div>
                    )}
                  </div>
                </button>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </section>

      {/* Categories */}
      <section className="categories-section">
        <Swiper slidesPerView={4.2} spaceBetween={12}>
          {[
            "all",
            ...Object.keys(categories || {}).filter((id) => id !== "all"),
          ].map((catId) => {
            const cat = categories[catId];
            if (!cat) return null;
            return (
              <SwiperSlide key={catId}>
                <div
                  className={`cat-circle ${
                    selectedCategory === catId ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedCategory(catId);
                    setSearchTerm("");
                  }}
                >
                  {cat.categoryImage ? (
                    <img
                      src={`${baseURL}/${cat.categoryImage}`}
                      alt={cat.categoryName}
                    />
                  ) : (
                    <div className="cat-placeholder">🍽️</div>
                  )}
                </div>
                <p className="cat-name">{cat.categoryName}</p>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </section>

      {/* Items */}
      <section className="items-grid">
        {filteredItems.length ? (
          filteredItems.map((item) => (
            <div key={item._id} className="item-card">
              <div className="item-img">
                <img src={`${baseURL}/${item?.image}`} alt={item.Productname} />
                <span className="item-tag">
                  {item.category?.nameEN || "Item"}
                </span>
              </div>
              <div className="item-info">
                <h3>{item.Productname}</h3>
                <div className="item-footer">
                  <div>
                    <span className="price">
                      {Math.ceil(item.salePriceWithTax / 10) * 10}
                    </span>
                    <span className="curency">TRY</span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="no-results">No items found 🍽️</p>
        )}
      </section>
    </div>
  );
}
